require('./OKAsyncInformativeListItem.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

//@ utilities
const { formatText } = require('core/i18n').i18n;

// @ components
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
import { LoadingDots } from 'commonsComponents/loadingDots';


class OKInformativeList extends React.Component {

    render() {
        const { isLoading, isError } = this.props;
        const propsWithoutChildren = { ...this.props };
        delete propsWithoutChildren.children;

        const errorMessage = formatText('OKAsyncInformativeList-error');

        if (isLoading) {
            return (
                <OKInformativeListItem
                    {...propsWithoutChildren}
                    bodyText=""
                >
                    <LoadingDots color="dark" medium="medium" inline={true} />
                </OKInformativeListItem>
            );
        } else if (isError) {
            return (
                <OKInformativeListItem
                    className="ok-informative-list-item__body-text--error-state"
                    {...propsWithoutChildren}
                    bodyText={<p>
                        <i className="icon-error"></i>{errorMessage}
                    </p>}
                />
            );
        }

        return <OKInformativeListItem {...this.props} bodyWordBreak={false} />
    }
}

OKInformativeList.propTypes = {
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
};

module.exports = OKInformativeList;
